// extracted by mini-css-extract-plugin
export default {"section_desc":"reachcontent_section_desc__oyfxS","sidehead_section":"reachcontent_sidehead_section__7xesV","impactData":"reachcontent_impactData__jFI1Q"};